import { useTranslation } from 'react-i18next'
import { Button, Modal } from '@/components/ui'

interface QRCodeGenerateModalProps {
  isOpen: boolean
  onClose: () => void
  onReload: () => Promise<void>
  isLoading?: boolean
}

export function QRCodeGenerateModal({
  isOpen,
  onClose,
  onReload,
  isLoading = false,
}: QRCodeGenerateModalProps) {
  const { t } = useTranslation()

  const handleReload = async () => {
    await onReload()
    onClose()
  }

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={open => !open && onClose()}
      title={t('qrCode.reloadTitle')}
      titlePosition='center'
      showCloseButton={false}
    >
      <div className='space-y-6'>
        <div className='text-sm text-gray-600 text-center space-y-1'>
          <p>{t('qrCode.reloadMessageLine1')}</p>
          <p>{t('qrCode.reloadMessageLine2')}</p>
        </div>
        <Button
          type='button'
          className='w-full h-11 font-medium bg-red-600 hover:bg-red-700 text-white'
          onClick={handleReload}
          disabled={isLoading}
        >
          {isLoading ? t('common.processing') : t('qrCode.reload')}
        </Button>
      </div>
    </Modal>
  )
}
